import { SwiperOptions } from 'swiper';

// nnkitodo [v2later] voir pour lazyload les slides pour éviter appels en plus sur celles non affichées (list exam ou list exam groups)
export class SwiperConfig {
  title: string;
  config: SwiperOptions;

  constructor(
    title: string,
    spaceBetween?: number,
    autoHeight?: boolean,
    hidePagination?: boolean,
    slidesPerView?: number,
    autoPlayDelay?: number
  ) {
    this.title = title;
    this.config = {
      slidesPerView: slidesPerView ? slidesPerView : 'auto',
      spaceBetween: spaceBetween ? spaceBetween : 30,
      autoplay: autoPlayDelay
        ? {
            delay: autoPlayDelay,
          }
        : false,
      grabCursor: true,
      autoHeight: autoHeight ? true : false,
      navigation: {
        prevEl: '#prev-' + title,
        nextEl: '#next-' + title,
      },
      pagination: hidePagination
        ? {}
        : {
            el: '#pagination-' + title,
            type: 'bullets',
            clickable: true,
          },
    };
  }

  setSpaceBetween(spaceBetween: number) {
    this.config.spaceBetween = spaceBetween;
  }

  enableAutoHeight() {
    this.config.autoHeight = true;
  }

  hidePagination() {
    this.config.pagination = null;
  }
}
